import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BackButton from "../common/backButton";
import ChartsDetail from "../common/ChartsDetail";
import Header from "../common/components/ui/Header";
import consts from "../consts";

function Graficos({ auth }) {
  const [cnpjs, setCnpjs] = useState([]);
  const [bancarios, setBancarios] = useState([]);
  const [loading, setLoading] = useState(true);

  const anoAtual = new Date().getFullYear();
  const [anoSelecionado, setAnoSelecionado] = useState(
    new Date().getFullYear()
  );

  const anos = [];
  for (let i = 2023; i <= anoAtual; i++) {
    anos.push(i);
  }

  useEffect(() => {
    axios
      .get(`${consts.API_URL}/permissions`, {
        params: { iduser: auth.user.id },
      })
      .then((resp) => {
        setCnpjs(resp.data);
      });
  }, [auth.user.id]);

  useEffect(() => {
    cnpjs.map(async (item) => {
      await axios
        .get(`${consts.API_URL}/bancariosCnpj`, { params: { cnpj: item.cnpj } })
        .then((resp) => {
          resp.data.map((item) => {
            return setBancarios((old) => [...old, item]);
          });
        });
    });
    setLoading(false);
  }, [cnpjs]);

  return (
    <div className="relative px-7">
      <div className="flex">
        <BackButton path="home" text="Voltar" />
      </div>
      <div className="flex items-center bg-gray-50 space-x-2 p-2">
        <Header text="Período" />
        <select
          name="selectAno"
          id="selectAno"
          value={anoSelecionado}
          onChange={(e) => setAnoSelecionado(String(e.target.value))}
          className="bg-white border border-gray-300 text-black py-2 px-3 rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400"
        >
          {anos.map((ano) => (
            <option key={ano} value={ano}>
              {ano}
            </option>
          ))}
        </select>
      </div>

      {loading ? null : (
        <div className="container flex flex-col gap-3 mx-auto mt-5">
          {bancarios.map((item, key) => {
            return (
              <ChartsDetail
                key={key}
                cnpj={item.cnpj}
                razao={item.razaosocial}
                banco={item.banco}
                fid={item.fid}
                agencia={item.agencia}
                conta={item.conta}
                ano={String(anoSelecionado)}
              ></ChartsDetail>
            );
          })}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({ auth: state.auth });
export default connect(mapStateToProps)(Graficos);
